import request from '@/utils/request'

const userApi = {
  Login: '/v1/student/login',
  RegisterPerson: '/v1/student/registerPerson',
  UserInfo:'/v1/student/queryInfo',
  Logout: '/v1/student/logout',
  UpdateInfo: '/v1/student/updateInfo',
  UpdatePass: '/v1/student/updateCurrentPass',
  Auth: '/v1/sysuser/auth',
  UploadFile: '/v1/file/uploadFile2',
}

/**
 * 上传文件
 * @param {FormData} formData
 * @returns {*}
 */
export function uploadFile (formData) {
  return request({
    url: userApi.UploadFile,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function registerPerson (parameter) {
  return request({
    url: userApi.RegisterPerson,
    method: 'post',
    data: parameter
  })
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login (parameter) {
  return request({
    url: userApi.Login,
    method: 'post',
    data: parameter
  })
}

export function updateInfo (parameter) {
  return request({
    url: userApi.UpdateInfo,
    method: 'post',
    data: parameter
  })
}


export function auth (parameter) {
  return request({
    url: userApi.Auth,
    method: 'post',
    data: parameter
  })
}

export function getSmsCaptcha (parameter) {
  return request({
    url: userApi.SendSms,
    method: 'post',
    data: parameter
  })
}

export function updatePass (parameter) {
  return request({
    url: userApi.UpdatePass,
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getCurrentUserNav () {
  return request({
    url: userApi.UserMenu,
    method: 'get'
  })
}

export function logout () {
  return request({
    url: userApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step (parameter) {
  return request({
    url: userApi.twoStepCode,
    method: 'post',
    data: parameter
  })
}
